import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import ActivateDependant from "./pages/ActivateDependant";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TwoFa from "./pages/TwoFactor";
import Missing from "./pages/Missing";
import Login from "./pages/Login";

// Admin pages
import EditGpConsultation from "./pages/Admin/EditGpconsultation";
import BookAssessment from "./pages/Admin/BookAssessment";
import AdminDashboard from "./pages/Admin/Dashboard";
import Enquiries from "./pages/Admin/Referrals";

import Notifications from "./pages/Notifications";

import Layout from "./components/Layout";

import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";

import PersistLogin from "./components/PersistLogin";
import ServiceAuth from "./components/ServiceAuth";
import RequireAuth from "./components/RequireAuth";
import CheckLogin from "./components/CheckLogin";
import Feature from "./components/Feature";

import CreateAccount from "./pages/CreateAccount";
import SignupComplete from "./pages/SignupComplete";
import MySchool from "./pages/Admin/MySchool";
import Profile from "./pages/Admin/Profile";
import useAuth from "./hooks/useAuth";
import FindOrg from "./pages/FindOrg";
import WellbeingSignposting from "./pages/Admin/WellbeingSignposting";

//Sub Pages
import ServicePage from "./pages/Admin/Partials/ServicePage";
import ImpersonateRedirect from "./pages/ImpersonateRedirect";
import MobileWebRedirect from "./pages/MobileWebRedirect";
import Dependants from "./pages/Admin/Dependants";
import PaymentSuccess from "./pages/PaymentSuccess";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import MobileLogin from "./pages/Admin/MobileLogin";
import Membership from "./pages/Membership";
import GetTheApp from "./pages/GetTheApp";

function App() {
  const { admin, auth } = useAuth();
  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = localStorage.getItem("impersonation_expire");
      if (expiry) {
        const expiryTime = new Date(expiry).getTime();
        if (Date.now() >= expiryTime) {
          localStorage.removeItem("impersonation_expire");
          localStorage.removeItem("impersonation");
          localStorage.removeItem("token");
          window.location.reload();
        }
      }
    }, 1000 * 60); // check every minute

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          {/* Public Routes */}
          <Route path="get-the-app" element={<GetTheApp />} />
          {/* Protected Routes */}
          <Route element={<PersistLogin />}>
            <Route element={<RequireAuth />}>
              <Route element={<MainLayout />}>
                <Route path="/" element={<AdminDashboard />} />
                <Route path="/referrals" element={<Enquiries />} />
                <Route path="/my-school" element={<MySchool />} />
                <Route path="/my-profile" element={<Profile />} />
                <Route path="/my-dependants" element={<Dependants />} />
                <Route path="/my-membership" element={<Membership />} />

                <Route
                  path="/referral/:booking"
                  element={<EditGpConsultation />}
                />

                <Route path="/book-assessment" element={<BookAssessment />} />
                <Route
                  path="/book-service/:serviceKey"
                  element={<ServicePage />}
                />
                <Route path="/notifications" element={<Notifications />} />
                <Route
                  path="/wellbeing-signposting"
                  element={<WellbeingSignposting />}
                />
              </Route>

              <Route
                path="/payment/success/:serviceName/:sessionId"
                element={<PaymentSuccess />}
              />

              <Route
                path="/membership/success"
                element={<SubscriptionSuccess />}
              />

              <Route path="*" element={<Missing />} />
            </Route>

            <Route element={<CheckLogin />}>
              <Route path="login" element={<Login />} />

              <Route path="2fa" element={<TwoFa />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="create-account/step-2" element={<CreateAccount />} />
              <Route path="create-account/step-1" element={<FindOrg />} />
              <Route path="signup-complete" element={<SignupComplete />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route
                path="activate-dependant"
                element={<ActivateDependant />}
              />
            </Route>

            <Route path="mobile-login" element={<MobileLogin />} />

            <Route path="impersonate" element={<ImpersonateRedirect />} />
            <Route path="mobile-web-redirect" element={<MobileWebRedirect />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />

            {/* Catch All */}
            <Route path="*" element={<Missing />} />
          </Route>
        </Route>
      </Routes>
      <Toaster richColors position="top-right" />
    </>
  );
}

export default App;
